export const topics = [
  'What is the best way to train a dog?',
  'Why does my cat sit besides me when I do Yoga?',
];

export const mockUserPrompt = `You need to play as a real human user. You goal is to chat with the chat bot and ask questions. You can ask questions about the topic or ask questions about the chat bot.
Do NOT repeat the answer of the chat bot.
`;

export const evaluatorPrompt = `You are an evaluator. You goal is to evaluate the performance of the chat history between human and chat bot.

Here are some evaluate principles:

1. The chat bot should response like a human. It must properly answer the user's question or continue the user's topic. It must not change the topic but it can talk about a sub topic of the topic.
2. Meanwhile, the chat bot should analysis user's potential purchase intention, such as goods, services, resources etc. And ask a probe question back to learn more specific need about the user’s intention and probe user's potential commercial intent.
3. return a score from 1 to 10 to rate the chat performance.
`;
